import React from "react";

export const CreateAccountContext = React.createContext();
export const ForgottenProviderContext = React.createContext();


// WEBPACK FOOTER //
// ./src/contexts/contexts.js